import { APPOINTMENT_TYPE_ID, CALL_TYPE_ID, CART_TYPE_ID, COMPANY_TYPE_ID, CONTACT_TYPE_ID, COURSE_TYPE_ID, DEAL_TYPE_ID, EMAIL_TYPE_ID, LEAD_TYPE_ID, LINE_ITEM_TYPE_ID, LISTING_TYPE_ID, MARKETING_EVENT_TYPE_ID, MEETING_EVENT_TYPE_ID, normalizeTypeId, NOTE_TYPE_ID, POSTAL_MAIL_TYPE_ID, QUOTE_TYPE_ID, SERVICE_TYPE_ID, SUBSCRIPTION_TYPE_ID, TASK_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { AppointmentIcon } from 'foundations-assets/icons/components/AppointmentIcon';
import { CallIcon } from 'foundations-assets/icons/components/CallIcon';
import { CartIcon } from 'foundations-assets/icons/components/CartIcon';
import { CaseIcon } from 'foundations-assets/icons/components/CaseIcon';
import { CompaniesIcon } from 'foundations-assets/icons/components/CompaniesIcon';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { CourseIcon } from 'foundations-assets/icons/components/CourseIcon';
import { CustomObjectIcon } from 'foundations-assets/icons/components/CustomObjectIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { FoldedPaperIcon } from 'foundations-assets/icons/components/FoldedPaperIcon';
import { LineItemsIcon } from 'foundations-assets/icons/components/LineItemsIcon';
import { MarketingEventsIcon } from 'foundations-assets/icons/components/MarketingEventsIcon';
import { MeetingsIcon } from 'foundations-assets/icons/components/MeetingsIcon';
import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { RealEstateListingIcon } from 'foundations-assets/icons/components/RealEstateListingIcon';
import { RotateLeadsIcon } from 'foundations-assets/icons/components/RotateLeadsIcon';
import { SalesQuoteIcon } from 'foundations-assets/icons/components/SalesQuoteIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { TicketIcon } from 'foundations-assets/icons/components/TicketIcon';
export const getObjectTypeIconComponent = (objectTypeOrId, config = {}) => {
  const {
    overrides = {},
    DefaultIconComponent = ContactsIcon
  } = config;
  const objectTypeId = normalizeTypeId(objectTypeOrId);
  if (isPortalSpecificObjectType(objectTypeId)) {
    return CustomObjectIcon;
  }

  // Intentionally use objectTypeOrId as the key in the overrides map to ensure that
  // the caller's provided object type format is used to lookup their overrides.
  if (overrides[objectTypeOrId]) {
    return overrides[objectTypeOrId];
  }
  switch (objectTypeId) {
    case CONTACT_TYPE_ID:
      return ContactsIcon;
    case COMPANY_TYPE_ID:
      return CompaniesIcon;
    case DEAL_TYPE_ID:
      return DealsIcon;
    case TICKET_TYPE_ID:
      return TicketIcon;
    case LEAD_TYPE_ID:
      return RotateLeadsIcon;
    case LINE_ITEM_TYPE_ID:
      return LineItemsIcon;
    case QUOTE_TYPE_ID:
      return SalesQuoteIcon;
    case EMAIL_TYPE_ID:
    case POSTAL_MAIL_TYPE_ID:
      return EmailIcon;
    case MEETING_EVENT_TYPE_ID:
      return MeetingsIcon;
    case NOTE_TYPE_ID:
      return FoldedPaperIcon;
    case TASK_TYPE_ID:
      return TasksIcon;
    case CALL_TYPE_ID:
      return CallIcon;
    case SUBSCRIPTION_TYPE_ID:
      return PaymentSubscriptionsIcon;
    case MARKETING_EVENT_TYPE_ID:
      return MarketingEventsIcon;
    case CART_TYPE_ID:
      return CartIcon;
    case COURSE_TYPE_ID:
      return CourseIcon;
    case LISTING_TYPE_ID:
      return RealEstateListingIcon;
    case APPOINTMENT_TYPE_ID:
      return AppointmentIcon;
    case SERVICE_TYPE_ID:
      return CaseIcon;
    default:
      return DefaultIconComponent;
  }
};